import React from 'react'
import { IconArrowBottom } from '../icons/Icons'

const Select = ({ name, value, textLabel, className = '', onChange, dataOptions, required = false }) => {
    return (
        <label className="text-sm font-light flex items-center justify-between">
            <div className='flex'>{textLabel} {required && <span className='text-red-500'>*</span>}</div>
            <div className={`relative inline-flex ${className}`}>
                <select
                    className={`appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal w-full`}
                    name={`${name}`}
                    required={required}
                    value={value}
                    onChange={onChange}
                >
                    <option value=''>Seleccionar</option>
                    {
                        dataOptions.map(data => (
                            <option
                                key={data.id}
                                value={data.id}
                            >
                                {data.name}
                            </option>
                        ))
                    }
                </select>
                <IconArrowBottom className='w-3 h-3 text-gray-400/50 absolute right-2 top-3' />
            </div>
        </label>
    )
}

export default Select